"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var differenceInCalendarDays = require("date-fns/difference_in_calendar_days");
var differenceInCalendarWeeks = require("date-fns/difference_in_calendar_weeks");
var differenceInCalendarMonths = require("date-fns/difference_in_calendar_months");
var differenceInYears = require("date-fns/difference_in_years");
var differenceInHours = require("date-fns/difference_in_hours");
var differenceInMinutes = require("date-fns/difference_in_minutes");
var differenceInSeconds = require("date-fns/difference_in_seconds");
var formatDate = require("date-fns/format");
var buildFormattingTokensRegExp = require("date-fns/locale/_lib/build_formatting_tokens_reg_exp");
var formatter_1 = require("./formatter");
var typeChecks_1 = require("./typeChecks");
function getDateDifference(endDate, startDate, period) {
    var dateDifference = 0;
    if (period === 'SECONDS') {
        dateDifference = differenceInSeconds(endDate, startDate);
    }
    if (period === 'MINUTES') {
        dateDifference = differenceInMinutes(endDate, startDate);
    }
    if (period === 'HOURS') {
        dateDifference = differenceInHours(endDate, startDate);
    }
    if (period === 'DAYS') {
        dateDifference = differenceInCalendarDays(endDate, startDate);
    }
    if (period === 'WEEKS') {
        dateDifference = differenceInCalendarWeeks(endDate, startDate);
    }
    if (period === 'MONTHS') {
        dateDifference = differenceInCalendarMonths(endDate, startDate);
    }
    if (period === 'YEARS') {
        dateDifference = differenceInYears(endDate, startDate);
    }
    // date-fns differenceIn* functions may return a negative value if startDate is before endDate
    // The difference is still valid as long as we ensure a positive value
    return dateDifference < 0 ? Math.abs(dateDifference) : dateDifference;
}
exports.getDateDifference = getDateDifference;
function hasDateExpired(startDate, duration, now) {
    if (!now) {
        now = new Date();
    }
    var dateDifference = getDateDifference(now, startDate, duration.period);
    return dateDifference >= duration.value;
}
exports.hasDateExpired = hasDateExpired;
/**
 * Validate whether the parameter is a Date object and is not "Invalid Date"
 *
 * @export
 * @param date
 * @returns
 */
function isValidDate(date) {
    return typeChecks_1.isDate(date) && !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
/**
 * Creates a new Date object using the date string (YYYY-MM-DD HH:mm:SS) provided within the UTC time zone
 *
 * @export
 * @param [dateStr]
 * @returns
 */
function getDateAsUTC(dateStr) {
    var userDate = new Date(dateStr);
    var year = formatter_1.padStart(userDate.getFullYear(), 4, '0');
    var month = formatter_1.padStart(userDate.getMonth() + 1, 2, '0');
    var day = formatter_1.padStart(userDate.getDate(), 2, '0');
    var hours = formatter_1.padStart(userDate.getHours(), 2, '0');
    var minutes = formatter_1.padStart(userDate.getMinutes(), 2, '0');
    var seconds = formatter_1.padStart(userDate.getSeconds(), 2, '0');
    var utcDateStr = year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "Z";
    return new Date(utcDateStr);
}
exports.getDateAsUTC = getDateAsUTC;
/**
 * Create a new Date object using the date string (YYYY-MM-DD HH:mm:SS) provided within the User's time zone, converting it to UTC.
 *
 * @export
 * @param [dateStr]
 * @returns
 */
function getUTCDate(dateStr) {
    var userDate = new Date(dateStr);
    var year = formatter_1.padStart(userDate.getUTCFullYear(), 4, '0');
    var month = formatter_1.padStart(userDate.getUTCMonth() + 1, 2, '0');
    var day = formatter_1.padStart(userDate.getUTCDate(), 2, '0');
    var hours = formatter_1.padStart(userDate.getUTCHours(), 2, '0');
    var minutes = formatter_1.padStart(userDate.getUTCMinutes(), 2, '0');
    var seconds = formatter_1.padStart(userDate.getUTCSeconds(), 2, '0');
    var utcDateStr = year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "Z";
    return new Date(utcDateStr);
}
exports.getUTCDate = getUTCDate;
function getUTCDateString(date) {
    if (!date) {
        date = new Date();
    }
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth() + 1;
    var day = date.getUTCDate();
    return formatter_1.padStart(year, 4, '0') + "-" + formatter_1.padStart(month, 2, '0') + "-" + formatter_1.padStart(day, 2, '0');
}
exports.getUTCDateString = getUTCDateString;
function getUTCFullYear(date) {
    if (!date) {
        date = new Date();
    }
    return date.getUTCFullYear();
}
exports.getUTCFullYear = getUTCFullYear;
function formatDateWithStringFormat(date, format, translate) {
    var locale = {
        distanceInWords: null,
        format: buildFormatLocale(translate),
    };
    return formatDate(date, format, { locale: locale });
}
exports.formatDateWithStringFormat = formatDateWithStringFormat;
exports.months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
exports.monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
exports.weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
exports.weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
exports.meridiemUppercase = ['AM', 'PM'];
exports.meridiemLowercase = ['am', 'pm'];
exports.meridiemFull = ['a.m.', 'p.m.'];
function buildFormatLocale(translate) {
    // Note: in English, the names of days of the week and months are capitalized.
    // If you are making a new locale based on this one, check if the same is true for the language you're working on.
    // Generally, formatted dates should look like they are in the middle of a sentence,
    // e.g. in Spanish language the weekdays and months should be in the lowercase.
    translateArray(translate, exports.months3char, exports.monthsFull, exports.weekdays2char, exports.weekdays3char, exports.weekdaysFull, exports.meridiemUppercase, exports.meridiemLowercase, exports.meridiemFull);
    var formatters = {
        // Month: Jan, Feb, ..., Dec
        // tslint:disable-next-line:function-name
        'MMM': function (date) {
            return exports.months3char[date.getMonth()];
        },
        // Month: January, February, ..., December
        // tslint:disable-next-line:function-name
        'MMMM': function (date) {
            return exports.monthsFull[date.getMonth()];
        },
        // Day of week: Su, Mo, ..., Sa
        // tslint:disable-next-line:function-name
        'dd': function (date) {
            return exports.weekdays2char[date.getDay()];
        },
        // Day of week: Sun, Mon, ..., Sat
        // tslint:disable-next-line:function-name
        'ddd': function (date) {
            return exports.weekdays3char[date.getDay()];
        },
        // Day of week: Sunday, Monday, ..., Saturday
        // tslint:disable-next-line:function-name
        'dddd': function (date) {
            return exports.weekdaysFull[date.getDay()];
        },
        // AM, PM
        // tslint:disable-next-line:function-name
        'A': function (date) {
            return (date.getHours() / 12) >= 1 ? exports.meridiemUppercase[1] : exports.meridiemUppercase[0];
        },
        // am, pm
        // tslint:disable-next-line:function-name
        'a': function (date) {
            return (date.getHours() / 12) >= 1 ? exports.meridiemLowercase[1] : exports.meridiemLowercase[0];
        },
        // a.m., p.m.
        // tslint:disable-next-line:function-name
        'aa': function (date) {
            return (date.getHours() / 12) >= 1 ? exports.meridiemFull[1] : exports.meridiemFull[0];
        },
    };
    // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
    var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
    ordinalFormatters.forEach(function (formatterToken) {
        formatters[formatterToken + 'o'] = function (date, formatters) {
            // not using ordinal for now
            // return ordinal(formatters[formatterToken](date));
            return formatters[formatterToken](date);
        };
    });
    return {
        formatters: formatters,
        formattingTokensRegExp: buildFormattingTokensRegExp(formatters),
    };
}
exports.buildFormatLocale = buildFormatLocale;
// function ordinal(number) {
// 	const rem100 = number % 100;
// 	if (rem100 > 20 || rem100 < 10) {
// 		switch (rem100 % 10) {
// 			case 1:
// 				return number + 'st';
// 			case 2:
// 				return number + 'nd';
// 			case 3:
// 				return number + 'rd';
// 		}
// 	}
// 	return number + 'th';
// }
function translateArray(translate) {
    var arrays = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        arrays[_i - 1] = arguments[_i];
    }
    if (translate) {
        for (var _a = 0, arrays_1 = arrays; _a < arrays_1.length; _a++) {
            var arr = arrays_1[_a];
            for (var i = 0; i < arr.length; i++) {
                arr[i] = translate(arr[i]);
            }
        }
    }
}
exports.translateArray = translateArray;
//# sourceMappingURL=date.js.map